var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInPersonDelivery = function SvgInPersonDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#InPersonDelivery_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M5.68 17.79c.795.014 1.58.17 2.32.46.53.27 1.3.65 2.7 1.21a4.6 4.6 0 0 0 1.45.23c.514 0 1.023-.1 1.5-.29l7-2.16h.05a1.63 1.63 0 0 0 1.16-2.13M21.83 15.09a2 2 0 0 0-2.55-.82l-3.15.73a1.94 1.94 0 0 0-1.27-1v0l-3.45-1a3.8 3.8 0 0 0-2.89-1.15 3.71 3.71 0 0 0-2.81 1.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.23 15.29c0 1.82-2.62.53-3.33.29"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M2.04 17.64v-4.5a1.71 1.71 0 0 1 1.71-1.71h1a.75.75 0 0 1 .75.75v6.42a.75.75 0 0 1-.75.75h-1a1.71 1.71 0 0 1-1.71-1.71M7.21 6.38H3.53M9.16 8.37h-3M3.82 8.37v.01M16.15 4.43v4.75M11.36 12.62V6.47a2.12 2.12 0 0 1 2-2.25h5.36a2.12 2.12 0 0 1 2 2.25v7.38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "InPersonDelivery_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgInPersonDelivery;